import React, { useRef, useEffect, useState } from 'react';
import ShowError from "../shared/ShowError";
import ShowConfirm from "../shared/ShowConfirm";
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import GeneralDialogFooter from '../shared/GeneralDialogFooter';
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Checkbox } from 'primereact/checkbox';

const SelectTimeIndexes = ({ onChange, onClose}) => {
    const [loading, setLoading] = useState(true);
    const [timeIndexes, setTimeIndexes] = useState([true, false, false, false, false, false]);
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [saving, setSaving] = useState(false);

    useEffect(() => {
     
    }, []);

    const editDialogFooter = function(){
        return (
            <GeneralDialogFooter onOkClick={()=>{saveItem()}} onCancelClick={()=>{onClose()}} saving={saving} />
        )
    }
    const saveItem = function(){
        var co = 0;
        for(var i=0;i<6;i++)
            if(timeIndexes[i]) co++;
        if(co == 0){
            setErorVisible(true);
            setErrorMessage("هیچ زنگی انتخاب نشده است");
            return;
        }
        onChange(timeIndexes);        
    }
    const onCheckboxChange = (e, index) => {
        var tmp = [...timeIndexes];
        tmp[index] = e.checked;
        setTimeIndexes(tmp);
    }
    return (
        <>
            <Dialog visible={true} style={{ width: '50rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }}
            header="انتخاب زنگ" modal className="p-fluid" footer={() => editDialogFooter()} onHide={() => onClose()}>
                <table style={{width:"100%", borderCollapse:"collapse"}}>
                    <tbody>
                        {
                            timeIndexes.map((item, index)=>{
                                return(
                                    <tr>
                                        <td>
                                            <div className="flex align-items-center" style={{marginTop:"10px"}}>
                                                <Checkbox inputId={"chk_" + index} onChange={(e)=>{onCheckboxChange(e, index)}} checked={timeIndexes[index]} />
                                                <label htmlFor={"chk_" + index} className="ml-2"> &nbsp;{util.getTimeIndexName(index)}</label>
                                            </div>                
                                        </td>
                                    </tr>
                                )
                            })
                        }                
                        <tr><td colSpan={2}>&nbsp;</td></tr>
                    </tbody>
                </table>

            </Dialog>
        
              <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
        </>
    )
};

export default SelectTimeIndexes;